import AedFlag from '~/icons/flags/AedFlag';
import AudFlag from '~/icons/flags/AudFlag';
import BdtFlag from '~/icons/flags/BdtFlag';
import BsdFlag from '~/icons/flags/BsdFlag';
import CadFlag from '~/icons/flags/CadFlag';
import ChfFlag from '~/icons/flags/ChfFlag';
import EurFlag from '~/icons/flags/EurFlag';
import GbpFlag from '~/icons/flags/GbpFlag';
import InrFlag from '~/icons/flags/InrFlag';
import JpyFlag from '~/icons/flags/JpyFlag';
import MyrFlag from '~/icons/flags/MyrFlag';
import NgnFlag from '~/icons/flags/NgnFlag';
import NzdFlag from '~/icons/flags/NzdFlag';
import UsdFlag from '~/icons/flags/UsdFlag';
import VndFlag from '~/icons/flags/VndFlag';
import ZarFlag from '~/icons/flags/ZarFlag';

export const CURRENCY_LIST = [
  {
    label: 'USD - United States dollar',
    miniLabel: 'USD',
    value: 'USD',
    symbol: '$',
    logo: UsdFlag,
  },
  {
    label: 'EUR - Euro',
    miniLabel: 'EUR',
    value: 'EUR',
    symbol: '€',
    logo: EurFlag,
  },
  {
    label: 'AUD - Australian dollar',
    miniLabel: 'AUD',
    value: 'AUD',
    symbol: 'AUD',
    logo: AudFlag,
  },
  {
    label: 'CAD - Canadian dollar',
    miniLabel: 'CAD',
    value: 'CAD',
    symbol: 'CAD',
    logo: CadFlag,
  },
  {
    label: 'GBP - British pound',
    miniLabel: 'GBP',
    value: 'GBP',
    symbol: '£',
    logo: GbpFlag,
  },
  {
    label: 'NZD - New Zealand dollar',
    miniLabel: 'NZD',
    value: 'NZD',
    symbok: 'NZD',
    logo: NzdFlag,
  },
  {
    label: 'ZAR - South African rand',
    miniLabel: 'ZAR',
    value: 'ZAR',
    symbol: 'ZAR',
    logo: ZarFlag,
  },
  {
    label: 'INR - Indian rupee',
    miniLabel: 'INR',
    value: 'INR',
    symbol: '₹',
    logo: InrFlag,
  },
  {
    label: 'CHF - Swiss franc',
    miniLabel: 'CHF',
    value: 'CHF',
    symbol: 'CHF',
    logo: ChfFlag,
  },
  {
    label: 'AED - United Arab Emirates dirham',
    miniLabel: 'AED',
    value: 'AED',
    symbol: 'AED',
    logo: AedFlag,
  },
  {
    label: 'JPY - Japanese yen',
    miniLabel: 'JPY',
    value: 'JPY',
    symbol: '¥',
    logo: JpyFlag,
  },
  {
    label: 'VND - Vietnamese dong',
    miniLabel: 'VND',
    value: 'VND',
    symbol: 'VND',
    logo: VndFlag,
  },
  {
    label: 'BDT - Bangladeshi taka',
    miniLabel: 'BDT',
    value: 'BDT',
    symbol: 'BDT',
    logo: BdtFlag,
  },
  {
    label: 'MYR - Malaysian Ringgit',
    miniLabel: 'MYR',
    value: 'MYR',
    symbol: 'MYR',
    logo: MyrFlag,
  },
  {
    label: 'BSD - Bahamian Dollar',
    miniLabel: 'BSD',
    value: 'BSD',
    symbol: 'BSD',
    logo: BsdFlag,
  },
  {
    label: 'NGN - Nigerian Naira',
    miniLabel: 'NGN',
    value: 'NGN',
    symbol: '₦',
    logo: NgnFlag,
  },
];

export const INV_ID_LIST = [
  {
    label: 'Template 0',
    value: 'inv0',
  },
  {
    label: 'Template 1',
    value: 'inv1',
  },
  {
    label: 'Template 2',
    value: 'inv2',
  },
  {
    label: 'Template 3',
    value: 'inv3',
  },
  {
    label: 'Template 4',
    value: 'inv4',
  },
  {
    label: 'Template 5',
    value: 'inv5',
  },
  {
    label: 'Template 6',
    value: 'inv6',
  },
  {
    label: 'Template 7',
    value: 'inv7',
  },
];

export const getOnlyCurrencySign = (currency = 'INR') => {
  for (const currencyItem of CURRENCY_LIST) {
    if (currencyItem.value == currency) {
      return currencyItem.symbol;
    }
  }
  return currency;
};

export const fmPrice = (currency: string, price: number | string) => {
  if (price && Number(price)) {
    price = parseFloat(price.toString());
  } else {
    price = 0;
  }

  // Round to 2 decimal places and ensure trailing zero if needed
  let formattedPrice = (Math.round(price * 100) / 100).toFixed(2);

  // Choose number format based on currency
  const numberFormat = new Intl.NumberFormat(currency === 'INR' ? 'en-IN' : 'en-US');

  // Extract integer and decimal parts
  const [integerPart, decimalPart] = formattedPrice.split('.');

  // Format the integer part with commas and append decimal part
  return `${getOnlyCurrencySign(currency)}${numberFormat.format(
    Number(integerPart),
  )}.${decimalPart}`;
};

// export const getAmount = (itemData: IFormItem) => {
//   const qty = parseFloat(itemData.quantity) || 0;
//   const price = parseFloat(itemData.price) || 0;
//   return qty * price;
// };

// export const getTotalAmountDetails = (formData: IFormData) => {
//   let subTotal = 0;
//   let discount = parseFloat(formData.discount) || 0;

//   // Sub Total
//   for (const eachItem of formData.items) {
//     subTotal += getAmount(eachItem);
//   }

//   // Discount
//   if (formData.discountType === 'percent') {
//     discount = (subTotal * discount) / 100;
//   }

//   const totalAfterDiscount = subTotal - discount;

//   // Tax
//   let tax = parseFloat(formData.tax) || 0;
//   if (formData.taxType === 'percent') {
//     tax = (totalAfterDiscount * tax) / 100;
//   }

//   const totalAfterTax = totalAfterDiscount + tax;

//   // Shipping
//   let shipping = parseFloat(formData.shipping) || 0;
//   if (formData.shippingType === 'percent') {
//     shipping = (totalAfterTax * shipping) / 100;
//   }

//   const totalAmount = totalAfterTax + shipping;

//   return { subTotal, discount, tax, shipping, totalAmount };
// };
